<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 6/2/2023
  -->

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {ViewModeEnum} from "@/utils/helpers";

export default {
	name: "ViewModeComponent",
	extends: BaseComponent,

	props: {
		viewMode: {ViewModeEnum, default: "VIEW"},
	},

	computed: {

		isReadonlyMode(){
			return !this.isAddMode && !this.isEditMode
		},
		isAddMode() {
			return this.viewMode === ViewModeEnum.ADD
		},
		isEditMode() {
			return this.viewMode === ViewModeEnum.EDIT
		},
		isDeleteMode() {
			return this.viewMode === ViewModeEnum.DELETE
		},
		isViewMode() {
			return this.viewMode === ViewModeEnum.VIEW
		},
		isDemoMode() {
			return this.viewMode === ViewModeEnum.DEMO
		},
		isAnswerMode() {
			return this.viewMode === ViewModeEnum.ANSWER
		},

		getAddModeValue() {
			return ViewModeEnum.ADD
		},
		getEditModeValue() {
			return ViewModeEnum.EDIT
		},
		getDeleteModeValue() {
			return ViewModeEnum.DELETE
		},
		getViewModeValue() {
			return ViewModeEnum.VIEW
		},
		getAnswerModeValue() {
			return ViewModeEnum.ANSWER
		},
	},
}
</script>

<style lang="scss">

</style>
